import * as React from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'

import { track } from '@amplitude/analytics-browser'
import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import ContactButton from 'modules/billing/components/ContactButton'
import subscriptions from 'modules/billing/store/collections/subscriptions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const PaymentError = () => {
  const { pathname } = useLocation()
  const currentSubscription = subscriptions.current
  const [searchParams] = useSearchParams()

  const emitContactCxRequest = () => {
    track(trackingEvents.onboarding.requestToContact, {
      page_path: pathname,
      page_url: window.location.href,
      request_type: 'Contact CX',
      from: 'payment_success_button',
      company_plan: subscriptions.current.inFreeTrial
        ? ['free']
        : currentSubscription.chargebeeSubscriptionItems.map((e) => e.item_price_id),
    })
  }

  track(trackingEvents.billing.upgradePlanError, { type: searchParams.get('type') ?? 'unknown' })

  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <Box
        flexDirection="column"
        gap="s32"
        textAlign="center"
        alignItems="center"
        justifyContent="center"
        style={{ height: '70vh' }}
      >
        <Box
          padding="s16"
          border={{
            all: {
              width: 's1',
              style: 'solid',
              color: 'radicalRed200',
            },
          }}
          borderRadius={{
            all: 'rel500',
          }}
        >
          <Icon.Large icon="alert" color="radicalRed1000" />
        </Box>
        <Box gap="s16" style={{ maxWidth: '540px' }}>
          <Text size="500" weight="semibold" color="grey1000">
            {i18n.t('pricing_plans.error.header.title')}
          </Text>
          <Text.Normal size="300" color="grey800">
            {i18n.t('pricing_plans.error.header.sentence')}
          </Text.Normal>
        </Box>
        <ContactButton
          type="primary"
          ctaLabel={i18n.t('pricing_plans.error.action.contact_us')}
          emitEventHandler={emitContactCxRequest}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

const PaymentErrorPage = () => (
  <AuthorizeUser>
    <PaymentError />
  </AuthorizeUser>
)

export default PaymentErrorPage
